module.exports = __webpack_public_path__ + "img/certificate04-5.f140a08b.jpg";